module.exports = __webpack_public_path__ + "img/switchG2.b72053a3.svg";